import { render, staticRenderFns } from "./ClientsComponent.vue?vue&type=template&id=6c678c68"
import script from "./ClientsComponent.vue?vue&type=script&lang=js"
export * from "./ClientsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports